// extracted by mini-css-extract-plugin
export default {"hed":"il","blend":"jl","resultsBox":"kl","left":"ll","right":"ml","center":"nl","base":"ol","milk":"pl","text":"ql","hyroxresult":"rl","margin":"sl"};
    if(module.hot) {
      // 1711394575569
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  